var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShared = function SvgShared(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#shared_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M7.499 5.833h5c2.75 0 4.124 0 4.979.854.854.855.854 2.23.854 4.98v.833c0 2.75 0 4.124-.854 4.979-.855.854-2.23.854-4.98.854h-.833c-2.75 0-4.124 0-4.979-.854-.854-.855-.854-2.23-.854-4.98v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.668 5.833h2.5M5.832 4.167v-2.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shared_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgShared;